import { Component, OnInit } from '@angular/core';
import { MemberQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-account-details-page',
  templateUrl: './account-details-page.component.html',
  styleUrls: ['./account-details-page.component.scss'],
})
export class AccountDetailsPageComponent implements OnInit {
  name$: Observable<string>;
  populations = Populations;
  constructor(private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName} ${m.Surname}`;
        }
        return '';
      })
    );
  }
}
